import SIDEBAR_CONFIG from "./SidebarConfig";

export { SIDEBAR_CONFIG };
